<div class="flex" style="margin-top: 15px;" *ngIf="propertyTypes && propertyTypes.length > 0">
  <div class="card w-full">
    <div class="p-datatable p-component p-datatable-striped p-datatable-hoverable-rows">
      <p-table
        [(first)]="first"
        [(rows)]="rows"
        [value]="propertyTypes"
        [totalRecords]="totalPropertyTypes"
        [breakpoint]="'DATATABLE_BREAKPOINT' | appConfig"
        [paginator]="true"
        [rowsPerPageOptions]="[10,25,50]"
        [lazy]="true"
        (onPage)="onPageChange($event)"
      >
        <ng-template pTemplate="header">
          <tr>
            <th>{{'attribute.name' | transloco}}</th>
            <th>{{'attribute.unit' | transloco}}</th>
            <th>{{'attribute.dataType' | transloco}}</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-type>
          <tr *ngIf="!loadingPropertyTypes">
            <td>
              <span class="p-column-title bold">{{'attribute.name' | transloco}}</span>
              {{type.name}}
            </td>
            <td>
              <span class="p-column-title bold">{{'attribute.unit' | transloco}}</span>
              {{type.unit}}
            </td>
            <td>
              <span class="p-column-title bold">{{'attribute.dataType' | transloco}}</span>
              {{type.dataType}}
            </td>
          </tr>
          <tr *ngIf="loadingPropertyTypes">
            <td class="p-3 bold"><p-skeleton height="1em"></p-skeleton></td>
            <td class="p-3 bold"><p-skeleton height="1em"></p-skeleton></td>
            <td class="p-3 bold"><p-skeleton height="1em"></p-skeleton></td>
          </tr>
        </ng-template>
        <ng-template pTemplate="summary">
          <div class="flex align-items-center justify-content-between" *ngIf="totalPropertyTypes == 0">
            {{'pagination.empty' | transloco}}
          </div>
          <div class="flex align-items-center justify-content-between" *ngIf="totalPropertyTypes > 0">
            Showing {{first+1}}
            to {{(first+rows) >= totalPropertyTypes ? totalPropertyTypes : (first+rows)}}
            of {{totalPropertyTypes}} {{totalPropertyTypes > 1 ? 'entries':'entry'}}
          </div>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
<div class="flex" style="margin-top: 15px;" *ngIf="propertyTypes && propertyTypes.length == 0">
  <div class="card w-full">
    <p class="text-xl text-center p-6 font-italic">{{'empty.propertyTypes' | transloco}}</p>
  </div>
</div>
<div class="flex" style="margin-top: 15px;" *ngIf="!propertyTypes">
  <div class="card w-full">
    <app-table-skeleton [rows]="14"></app-table-skeleton>
  </div>
</div>
